import React, { useState } from 'react';
import { Select, SelectOptionProps } from '@innovationnorway/component-library';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import ESAReporting from './ESAReporting';
import useSivaYearList from 'src/hooks/use-year-list-reporting';

const EsaYearSelect = () => {
  const yearList = useSivaYearList(2023);

  const { year: paramYear } = useParams();
  const currentYear = new Date().getFullYear();
  const year = !paramYear ? currentYear : Number(paramYear);
  const [selectedYear, setSelectedYear] = useState(paramYear || year.toString());

  const yearOptions: SelectOptionProps[] = useMemo(() => {
    return yearList.map((item) => ({ value: item.toString(), text: item.toString() }));
  }, [yearList]);

  return (
    <div className="stack">
      <Select
        value={selectedYear}
        className="width--20"
        label="Velg år"
        name="year"
        placeholder={paramYear}
        options={yearOptions}
        onChange={setSelectedYear}
      />

      <ESAReporting year={Number(selectedYear)} />
    </div>
  );
};

export default EsaYearSelect;
